export default [
  {
    id: 1,
    title: 'Как получить SSL-сертификат для своего домена центра поддержки',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Михаил' },
    category: {
      slug: 'configuration',
      icon: '📦',
      name: 'Установка и настройка',
    },
    views: 3400,
  },
  {
    id: 2,
    title: 'Настройка первого портала центра поддержки',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Иван' },
    category: { slug: 'onboarding', icon: '🧑‍🍳', name: 'Первые шаги' },
    views: 400,
  },
  {
    id: 3,
    title: 'Как организовать разделы базы знаний в vivaCRM',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Фёдор' },
    category: { slug: 'best-practices', icon: '⛺️', name: 'Лучшие практики' },
    views: 400,
  },
  {
    id: 4,
    title: 'Оформление центра поддержки под ваш бренд',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Анна' },
    category: { slug: 'design', icon: '🎨', name: 'Оформление' },
    views: 400,
  },
  {
    id: 5,
    title: 'Интеграция центра поддержки с внешними сервисами',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Светлана' },
    category: {
      slug: 'integrations',
      icon: '🔗',
      name: 'Интеграции',
    },
    views: 2800,
  },
  {
    id: 6,
    title: 'Управление правами доступа в центре поддержки',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Алексей' },
    category: {
      slug: 'administration',
      icon: '🔐',
      name: 'Администрирование',
    },
    views: 1200,
  },
  {
    id: 7,
    title: 'Создание и ведение разделов FAQ',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Елена' },
    category: {
      slug: 'content-management',
      icon: '📝',
      name: 'Контент',
    },
    views: 5600,
  },
  {
    id: 8,
    title: 'Поиск по статьям в центре поддержки',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Дмитрий' },
    category: {
      slug: 'features',
      icon: '🔍',
      name: 'Возможности',
    },
    views: 1800,
  },
  {
    id: 9,
    title: 'Аналитика посещений центра поддержки',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Раиса' },
    category: {
      slug: 'analytics',
      icon: '📊',
      name: 'Аналитика',
    },
    views: 3200,
  },
  {
    id: 10,
    title: 'Многоязычный центр поддержки в vivaCRM',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Карен' },
    category: {
      slug: 'localization',
      icon: '🌍',
      name: 'Локализация',
    },
    views: 900,
  },
  {
    id: 11,
    title: 'Инструкции по онлайн-записи на услуги для клиентов',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Ольга' },
    category: {
      slug: 'education',
      icon: '🎓',
      name: 'Обучение',
    },
    views: 4100,
  },
  {
    id: 12,
    title: 'Сбор отзывов и обратной связи в центре поддержки',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Николай' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
      name: 'Вовлечение',
    },
    views: 750,
  },
  {
    id: 13,
    title: 'Оптимизация статей центра поддержки для поисковиков',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Софья' },
    category: {
      slug: 'seo',
      icon: '🚀',
      name: 'SEO',
    },
    views: 2900,
  },
  {
    id: 14,
    title: 'Внутренняя база знаний для сотрудников',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Даниил' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
      name: 'Внутренние материалы',
    },
    views: 1500,
  },
];
